module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-image-3-800x533-cfe2292b4a80b5a006dec02eda425717.jpg";